// removed by extract-text-webpack-plugin
module.exports = {"block":"_2DLtJqn_48hVdeElBced6V","check":"_20crIypl14w5x1dR99vzpR","active":"_16HnabTomv9eGvB7wi2Z-O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/Checkbox.module.scss
// module id = 740
// module chunks = 0